//const baseURL = "http://localhost:80/tienda2025v5/public";
const baseURL = "https://tienda.virtualtech.com.ar";
export default baseURL;
